import req from './http.js'
import { apiAuth } from './fetch'

// 取得Container列表
export const apiGetContainers = (org_id) => req('get', '/optimize/container?org=' + org_id)

// 取得單個Container
export const apiGetContainer = (org_id, id) => req('get', `/optimize/container/id?org=${org_id}&id=${id}`, null).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 新增Container
export const apiCreateContainer = (params, org_id) => req('post', '/optimize/container?org=' + org_id, params)

// 刪除Container
export const apiDeleteContainer = (container_id, org_id) => req('delete', '/optimize/container?container_id=' + container_id + '&org=' + org_id)

// 取得實驗 or 衝動外掛列表
export const apiGetExperiments = async (data) => {
  try {
    const params = {
      org: data.org_id,
      container_id: data.container_id,
      containerId: data.container_id, 
      target_type: data.type,
      mode: data.mode || 'draft',
      page: data.page || 1,
      limit: data.limit || 10,
      key: data.keyword || ''
    }
    for(const key in params) {
      if(!params[key]) delete params[key]
    }
    const res = await apiAuth('GET', `/optimize/experience/v2`, params)
    if (res.status === 200) {
      return res.data.data
    }

    throw new Error('取得資料失敗')
  } catch (error) {
    return null
  }
}

// 新增 實驗 or 衝動外掛
export const apiCreateExperiment = async (org_id, data) => {
  const params = {
    org: org_id
  }
  const payload = {
    container_id: data.container_id,
    name: data.name,
    url: data.url,
    start_at: data.start_at,
    end_at: data.end_at,
    campaign_start_at: data.start_at,
    campaign_end_at: data.end_at,
    target_type: data.target_type,
    memo: data.memo,
  }
  const res = await apiAuth('POST', '/optimize/experience', { params, payload })
  if (res.status === 200) {
    return res.data.data
  }
  throw new Error('新增資料失敗')
}

// 刪除Experiment
export const apiDeleteExperiment = (experience_id, is_check, org_id) => req('delete', '/optimize/experience?experience_id=' + experience_id + '&is_check=' + is_check + '&org=' + org_id)

// 更新Experiment
export const apiPatchExperiment = (experience_id, org_id, params) => req('patch', '/optimize/experience?experience_id=' + experience_id +'&org=' + org_id, params)

// 更新Experiment
export const apiPatchExperimentWithData = (experience_id, org_id, params) => req(
    'patch',
    '/optimize/experience?experience_id=' + experience_id +'&org=' + org_id, params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 更新已部署過的 Experiment
export const apiEditReleaseExperiment = (experience_id, org_id, payload) => req('patch', `/optimize/experience/rename?id=${experience_id}&org=${org_id}`, payload).
then((res) => {
    return res.data
}).catch((error) => {
    throw error
})

// 取得單個實驗
export const apiGetExperience = (experience_id , org_id) => req('get', '/optimize/experience/by?experience_id=' + experience_id + '&org=' + org_id)

// 新增版本
export const apiCreateView = (params, org_id) => req('post', '/optimize/view?org=' + org_id, params)

// 刪除版本
export const apiDeleteView = (container_id, is_check, org_id) => req('delete', '/optimize/view?id=' + container_id + '&is_check=' + is_check + '&org=' + org_id)

// 更新版本
export const apiPatchView = (params, org_id) => req('patch', '/optimize/view/v3?org=' + org_id, params)

// 取得單一版本資訊 這隻尚未用到
export const apiGetView = (container_id, org_id) => req('get', '/optimize/view/by/v2?id=' + container_id + '&org=' + org_id)

export const apiGetViewWithData = (view_id, org_id) => req(
    'get', '/optimize/view/by/v2?id=' + view_id + '&org=' + org_id
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 更新版本出現機率
export const apiPatchViewPriority = (params, org_id) => req('patch', '/optimize/view/priority?org=' + org_id , params)

// 取得缺貨通知
export const apiGetNotify = (org_id) => req('get', '/optimize/notify?org=' + org_id)

// 綁定缺貨通知
export const apiPatchNotifyBind = (org_id, params) => req('post', '/optimize/notify/bind?org=' + org_id , params)

// 給哪一個實驗啟用缺貨通知
export const apiPatchExperienceNotifyActive = (experience_id, org_id, params) => req('patch', '/optimize/experience/notify/active?id=' + experience_id + '&org=' + org_id, params)

// 發布實驗
export const apiPatchExperienceRelease = (experience_id, org_id) => req('patch', '/optimize/experience/release?id=' + experience_id + '&org=' + org_id)

// 結束實驗
export const apiPatchExperienceDisable = (experience_id, org_id) => req('patch', '/optimize/experience/disable?id=' + experience_id + '&org=' + org_id)

// 取得網頁規則
export const apiGetExperienceRule = (experience_id, org_id) => req('get', '/optimize/experience/rule?exp_id=' + experience_id + '&org=' + org_id)

// 新增網頁規則
export const apiCreateExperienceRule = (org_id, params) => req('post', '/optimize/experience/rule?org=' + org_id, params)

// 更新網頁規則
export const apiUpdateExperienceRule = (org_id, params) => req('put', '/optimize/experience/rule?org=' + org_id, params)

// 刪除網頁規則
export const apiDeleteExperienceRule = (rule_id, org_id) => req('delete', '/optimize/experience/rule?rule_id=' + rule_id + '&org=' + org_id)

// 檢查網頁規則有符合的實驗(在實驗那層做檢查)
export const apiCheckMatchExperients = (org_id, params) => req('post', '/optimize/experience/rule/check?org=' + org_id, params)

// 取view預覽的暫時性token
export const apiGetPreviewToken = (org_id, v_id) =>req('get', '/optimize/preview/token?vid=' + v_id + '&org=' + org_id)

export const apiGetPreviewTokenWithData = (org_id, v_id) =>req('get', '/optimize/preview/token?vid=' + v_id + '&org=' + org_id).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

// 取得container 更新安裝狀態token
export const apiInstalledContainerStatus = (container_id, org_id) => req('patch', `/optimize/container/installed?org=${org_id}&id=${container_id}` , null).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

// 更新container資料
export const apiUpdateContainer = (params, container_id, org_id) => req('patch',`/optimize/container?id=${container_id}&org=${org_id}`, params).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

// 複製實驗
export const apiCopyExperience = (org_id, params) => req(
    'post', 
    `/optimize/experience/copy?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// version改名
export const apiRenameVersion = (org_id, id, params) => req(
    'patch',
    `/optimize/view/rename?id=${id}&org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
}) 

// 實驗改名
export const apiRenameExp = (org_id, id, params) => req(
    'patch',
    `/optimize/experience/rename?id=${id}&org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
}) 

// /adassistant/interest?org=11
export const apiSearchInterst = (org_id, params) => req(
    'post', 
    `/adassistant/interest/list?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiSearchInterstChroma = (org_id, params) => req(
    'post', 
    `/adassistant/interest/list/semantic?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiSearchSuggestion = (org_id, key, level, relatedness) => req(
    'post', 
    `/adassistant/interest/search?org=${org_id}`,
    {
        "key": key,
        "level": level,
        "relatedness": relatedness
    }
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiGetInterstHistory = (org_id, page_idx, limit, key) => req(
    'get', 
    `/adassistant/interest/history?key=${key}&page=${page_idx}&limit=${limit}&org=${org_id}`,
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiSearchSeed = (org_id, params) => req(
    'post', 
    `/adassistant/interest/seed?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiCopyVersion = (org_id, params) => req(
    'post', 
    `/optimize/view/copy?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiGetCopyView = (org_id, id) => req(
    'get', 
    `/optimize/view/copy/by?experience_id=${id}&org=${org_id}`,
).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

export const apiGetViewSchedule = (org_id, id) => req(
    'get', 
    `/viewschedule?experience_id=${id}&org=${org_id}`,
).then((res) => {
    return res.data.data
}).catch((error) =>{
    throw error
})

export const apiCreateViewSchedule = (org_id, params) => req(
    'post', 
    `/viewschedule?org=${org_id}`,
    params
).catch((error) => {
    throw error
})

export const apiUpdateViewSchedule = (org_id, params) => req(
    'patch',
    `/viewschedule?org=${org_id}`,
    params
).then((res) => res.data)
    .catch((error) => {
    throw error
})

export const apiDeleteViewSchedule = (org_id, id) => req(
    'delete', 
    `/viewschedule?id=${id}&org=${org_id}`,
).catch((error) => {
    throw error
})

export const apiGetSameRuleUrlList = async (org_id, experience_id) => {
    const params = {
        org: org_id,
        experience_id
    }
    const res = await apiAuth('GET', '/optimize/experience/rule/sitemap/match', params)
    if (res.status === 200) {
        return res.data.data
    }
    throw new Error('取得資料失敗')
}